<template>
    <div v-if="visible">
        <template v-if="applicationLinks.length > 0">
            <nav class="navbar navbar-sidebar application-bar" :style="{ width: `${applicationBarWidth}px` }">
                <ul class="navbar-nav">
                    <template v-for="(link, index) in applicationLinks">
                        <li class="nav-item mt-auto" :key="`applnk.${index}`" v-if="link.type == 'SPACER'"></li>
                        <li class="nav-item" :key="`applnk.${index}`" v-else>
                            <a
                                :href="link.url"
                                class="nav-link"
                                v-bind:class="{ active: link.isCurrent }"
                                data-toggle="collapse"
                                data-target=".navbar-collapse.show"
                                v-tooltip="{
                                    content: $t(link.label),
                                    trigger: expanded ? 'none' : 'hover',
                                    placement: 'right',
                                    classes: link.isCurrent ? 'active' : '',
                                }">
                                <span class="icon">
                                    <template v-if="link.icon && link.icon.type == 'custom'">
                                        <Icon
                                            :name="link.icon.name"
                                            :width="30"
                                            :height="30"
                                            :isOutlined="link.isCurrent ? false : true" />
                                    </template>

                                    <template v-else-if="link.icon">
                                        <font-awesome-icon :icon="[link.icon.type, link.icon.name]" />
                                    </template>
                                </span>
                                <span class="title">{{ $t(link.title) }}</span>
                            </a>
                        </li>
                    </template>
                </ul>
            </nav>
        </template>
        <nav
            class="navbar navbar-sidebar"
            :class="{ 'is-expanded': expanded }"
            :style="{ width: `${expanded ? sidebarWidthExpanded : sidebarWidth}px`, left: `${applicationBarWidth}px` }">
            <div class="brand-container">
                <div @click="handleBrandClick" class="brand" :style="homePageNavigation ? { cursor: 'pointer' } : {}">
                    <template v-if="!!this.$slots.logo"> <slot name="logo" /></template>
                    <template v-else>
                        <img :src="imageUri" />
                    </template>
                </div>
                <template v-if="!expanded && !!this.$slots.collapsedLogo">
                    <div class="brand-collapsed pointer" @click.prevent="handleCollapsedClick">
                        <slot name="collapsedLogo" />
                    </div>
                </template>
                <template v-if="showCollapse">
                    <a
                        href
                        @click.prevent="onToggle"
                        class="btn-expand"
                        v-tooltip="
                            expanded
                                ? null
                                : {
                                      content: $t('expand'),
                                      trigger: 'hover',
                                      placement: 'right',
                                  }
                        ">
                        <span class="icon">
                            <Icon name="Collapse" :width="11" :height="11" v-if="expanded" />
                            <Icon name="Expand" :width="11" :height="11" v-else />
                        </span>
                    </a>
                </template>
            </div>

            <ul class="navbar-nav">
                <template v-for="link in links">
                    <li class="header" v-if="link.type == 'HEADER'" :key="'head_' + link.id">
                        <span>{{ $t(link.title) }}</span>
                    </li>
                    <template v-else-if="link.type == 'SPACER'">
                        <!-- Free plan -->
                        <template v-if="!!$slots.sidebarExpanded && expanded">
                            <li class="nav-item">
                                <slot name="sidebarExpanded" />
                            </li>
                        </template>

                        <li class="nav-item mt-auto" :key="link.id"></li>
                    </template>
                    <li class="nav-item" :key="link.id" v-else>
                        <a
                            href
                            @click.prevent="goto(link.url)"
                            class="nav-link"
                            v-bind:class="{ active: link.isActive }"
                            data-toggle="collapse"
                            data-target=".navbar-collapse.show"
                            v-tooltip="
                                expanded
                                    ? null
                                    : {
                                          content: $t(link.title),
                                          trigger: 'hover',
                                          placement: 'right',
                                          classes: link.isActive ? 'active' : '',
                                      }
                            ">
                            <span class="icon">
                                <template v-if="link.icon && link.icon.type == 'custom'">
                                    <Icon :name="link.icon.name" />
                                </template>

                                <template v-else-if="link.icon">
                                    <font-awesome-icon :icon="[link.icon.type, link.icon.name]" />
                                </template>
                            </span>
                            <span class="title">{{ $t(link.title) }}</span>
                        </a>
                    </li>
                </template>
            </ul>
            <div class="mt-auto"></div>

            <template v-if="expanded">
                <slot name="bottomExpanded"></slot>
                <!-- profile -->
                <template v-if="user && user.profile">
                    <a :href="`${adminUri}`" class="profile">
                        <avatar
                            :url="user.profile.avatarUrl"
                            :firstName="user.profile.firstName"
                            :lastName="user.profile.lastName"
                            :hideName="true"
                            class="xl" />
                        <div class="tag mt15-xs mb5-xs">
                            {{ user.profile.tenantDisplayName }}
                        </div>
                        <div class="name">
                            {{ user.profile.firstName }}
                            {{ user.profile.lastName }}
                        </div>
                        <div class="email">
                            {{ user.profile.email }}
                        </div>
                    </a>
                    <router-link to="/signout" class="signout">
                        {{ $t('Signout') }}
                    </router-link>
                </template>
                <div class="copy-footer">
                    <span class="version">{{ version }}</span>
                    <template v-if="termsUrl">
                        <a :href="termsUrl" target="_blank" class="terms txt">{{ $t('termsAndConditions') }}</a>
                    </template>
                </div>
            </template>
            <template v-else>
                <template v-if="user && user.profile">
                    <div class="w100 d-flex h-center mb15-xs">
                        <ul class="navbar-nav">
                            <li class="nav-item">
                                <a href @click.prevent="onToggle" class="nav-link avatar">
                                    <span class="icon">
                                        <avatar
                                            :url="user.profile.avatarUrl"
                                            :firstName="user.profile.firstName"
                                            :lastName="user.profile.lastName"
                                            :hideName="true"
                                            class="m0" />
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </template>
            </template>
        </nav>
    </div>
</template>

<script>
import Icon from './../public/Icon.vue';
import avatar from './UserAvatar.vue';

import Vue from 'vue';
import VTooltip from 'v-tooltip';
Vue.use(VTooltip);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const SIDEBAR_WIDTH = 80;
const SIDEBAR_EXPANDED_WIDTH = 300;
const APPLICATIONBAR_WIDTH = 80;

export default {
    name: 'Sidebar',
    props: {
        config: {
            type: Object,
            required: true,
        },
        imageUri: {
            type: String,
        },
        user: {
            type: Object,
        },
        showCollapse: {
            type: Boolean,
            default: true,
        },
        homePageNavigation: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Icon,
        avatar,
        FontAwesomeIcon,
    },
    data() {
        return {
            expanded: false,
            visible: true,

            sidebarWidth: SIDEBAR_WIDTH,
            sidebarWidthExpanded: SIDEBAR_EXPANDED_WIDTH,
        };
    },
    computed: {
        version() {
            return window.env.VERSION;
        },
        links() {
            var links = [];
            if (this.config && this.config.links) {
                links = this.config.links.map((link) => {
                    //first check for actual link
                    //link.isActive = this.$route.path == link.url;
                    link.isActive = this.$route.path.indexOf(link.url) > -1;
                    //todo: check on route meta data
                    return link;
                });
            }
            return links;
        },
        termsUrl() {
            return this.config.termsUrl;
        },
        applicationLinks() {
            return Array.isArray(this.config.applications) ? this.config.applications : [];
        },
        applicationBarWidth() {
            return this.applicationLinks.length > 0 ? APPLICATIONBAR_WIDTH : 0;
        },
        currentApplication() {
            if (this.applicationLinks) {
                return this.applicationLinks.find((link) => {
                    return link.isCurrent;
                });
            }
            return false;
        },
        adminUri() {
            return window.env.ENHANSA_URL;
        },
    },
    created() {
        document.addEventListener('toggleSidebar', this.hideSidebar);
        document.addEventListener('hideSidebar', this.hideSidebar);
        window.addEventListener('resize', this.handleBodyPadding);
    },
    mounted() {
        this.handleSavedState();
        this.handleBodyPadding();
    },
    beforeDestroy() {
        this.removeBodyPadding();
        document.removeEventListener('toggleSidebar', this.hideSidebar);
        document.removeEventListener('hideSidebar', this.hideSidebar);
        window.removeEventListener('resize', this.handleBodyPadding);
    },
    methods: {
        hideSidebar() {
            this.visible = !this.visible;
            if (this.visible) {
                this.handleBodyPadding();
            } else {
                this.removeBodyPadding();
            }
        },
        removeBodyPadding() {
            var body = document.getElementsByTagName('body').item(0);
            body.style.paddingLeft = '15px';
        },
        handleBodyPadding() {
            let isMobile = window.matchMedia('only screen and (max-width: 767px)').matches;
            var body = document.getElementsByTagName('body').item(0);
            const expandedWidth = SIDEBAR_EXPANDED_WIDTH + this.applicationBarWidth;

            if (isMobile) {
                body.style.paddingLeft = '0px';
                body.style.paddingTop = '80px';
            } else {
                //add spacing to body
                body.style.paddingTop = '0px';
                body.style.paddingLeft = this.expanded
                    ? `${expandedWidth}px`
                    : `${this.applicationBarWidth + this.sidebarWidth}px`; //80+15->radius
                if (this.expanded) {
                    body.classList.add('sidebar-expanded');
                    body.classList.remove('sidebar-collapsed');
                } else {
                    body.classList.add('sidebar-collapsed');
                    body.classList.remove('sidebar-expanded');
                }
            }
        },
        handleSavedState() {
            let savedExpanded = localStorage.getItem(`sidebar.expanded`);
            this.expanded = savedExpanded ? JSON.parse(savedExpanded) : false;
        },
        onToggle() {
            this.expanded = !this.expanded;
            localStorage.setItem(`sidebar.expanded`, this.expanded);
            document.dispatchEvent(new CustomEvent('sidebar.toggled', { detail: this.expanded }));
            this.handleBodyPadding();
        },
        goToHomePage() {
            this.$router.push('/').catch((e) => {
                console.log('error', e);
            });
        },
        goto(link) {
            //close menu when mobile
            let isMobile = window.matchMedia('only screen and (max-width: 767px)').matches;
            if (isMobile) {
                this.onToggle();
            }
            this.$router.push(link).catch((e) => {
                console.log('error', e);
            });
        },
        handleBrandClick() {
            if (this.homePageNavigation) {
                this.goToHomePage();
            }
        },
        handleCollapsedClick() {
            if (this.homePageNavigation) {
                this.goToHomePage();
            }
            this.onToggle();
        },
    },
    i18n: {
        messages: {
            en: {
                Profile: 'Profile',
                Signout: 'Sign out',
                privacyPolicy: 'Privacy policy',
                termsAndConditions: 'Terms and Conditions',
                expand: 'Expand',
            },
            fr: {
                Profile: 'Profil',
                Signout: 'Se déconnecter',
                privacyPolicy: 'Politique de confidentialité',
                termsAndConditions: 'Conditions générales',
                expand: 'Ouvrir',
            },
            nl: {
                Profile: 'Profiel',
                Signout: 'Afmelden',
                privacyPolicy: 'Privacy beleid',
                termsAndConditions: 'Algemene voorwaarden',
                expand: 'Open',
            },
        },
    },
};
</script>

<style lang="scss">
.w100 {
    width: 100%;
}
.mb5-xs {
    margin-bottom: 5px;
}
/* Application Bar */
nav.navbar.navbar-sidebar.application-bar {
    left: 0;

    background-color: var(--applicationbar-bg-color);

    .navbar-nav {
        flex: 1;
        .nav-link {
            background-color: transparent;
            span.icon {
                width: 50px;
                height: 50px;
            }
            &.active {
                &,
                &:hover,
                &:active,
                &:focus {
                    background-color: var(--applicationbar-bg-color);
                }
            }
        }
    }
}

/* Regular SideBar */
nav.navbar.navbar-sidebar {
    position: fixed;
    top: 0;
    left: 80px;
    z-index: 9999;
    padding: 0;
    margin: 0;
    height: 100vh;

    background-color: var(--sidebar-bg-color);
    border-right: 2px solid #f2f3f3;
    box-shadow: none;

    flex-direction: column;
    align-items: flex-start;
    transition: all 100ms ease-out;
    transition: width 200ms ease-out, left 200ms ease-out;

    .brand-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-bottom: 15px;

        .brand {
            display: none;
        }
        .brand-collapsed {
            margin: 15px 0;
        }
        .btn-expand {
            height: 100%;
            width: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            outline: none;

            color: var(--color-txt);
            opacity: 0.5;
            &:hover,
            &:active,
            &:focus {
                opacity: 1;
            }
        }
    }

    //Expanded
    &.is-expanded {
        //Brand
        .brand-container {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-direction: row;
            padding: 0 15px;
            margin-bottom: 0px;
            height: 80px;

            .brand {
                width: 100%;

                display: flex;

                img {
                    width: 90%;
                }
            }
            .brand-collapsed {
                display: none;
            }
        }
        .navbar-nav {
            .nav-link {
                justify-content: flex-start;
                padding-left: 25px;
                span.title {
                    display: block;
                }
            }
            li.header {
                span {
                    opacity: 1;
                    visibility: visible;
                }
                &:before {
                    opacity: 0;
                    visibility: hidden;
                }
            }
        }
    }

    //Links
    .navbar-nav {
        flex-direction: column;
        width: 100%;
        display: flex;
        flex: 1;
        li {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0;
        }
        .nav-link {
            margin: 0;
            padding: 12px 0;
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
            transition: all 0.2s ease;
            position: relative;

            //border-left: 4px solid transparent;
            background-color: var(--sidebar-bg-color);
            color: var(--sidebar-color);

            span.icon {
                margin: 0;
                padding: 0px;
                justify-content: center;
                display: flex;
                width: 15px;
                height: 15px;
                justify-content: center;
                align-items: center;
                color: var(--sidebar-color);
            }
            span.title {
                margin-left: 10px;
                padding-top: 0px; //to align with icons
                top: 0;
                font-size: 1.4rem;
                font-weight: 500;
                display: none;
                text-align: left;
                color: var(--sidebar-color);
            }

            //execptions for avatar and expand links
            &.avatar {
                &:hover,
                &:active,
                &:focus {
                    //border-left: 4px solid transparent;
                    span.icon {
                        color: var(--sidebar-active-color);
                    }
                    span.title {
                        color: var(--sidebar-active-color);
                    }
                }
            }

            &.expand {
                margin-bottom: 15px;
            }

            &.router-link-active,
            &.active {
                &,
                &:hover,
                &:active,
                &:focus {
                    //border-left: 4px solid var(--sidebar-active-color);
                    background-color: var(--sidebar-active-bg);
                    span.icon {
                        color: var(--sidebar-active-color);
                    }
                    span.title {
                        color: var(--sidebar-active-color);
                    }
                }
            }
            &:hover,
            &:active,
            &:focus {
                //border-left: 4px solid var(--sidebar-active-color);
                background-color: var(--sidebar-hover-bg);
                outline: none;
                span.icon {
                    color: var(--sidebar-hover-color);
                }
                span.title {
                    color: var(--sidebar-hover-color);
                }
            }
        }
        li.header {
            position: relative;
            justify-content: flex-start;
            font-family: 'Inter', sans-serif;
            font-size: 1.2rem;
            font-weight: bold;
            text-transform: uppercase;
            color: var(--sidebar-color);
            opacity: 0.4;
            border-bottom: 0;
            height: auto;
            padding: 0;
            margin-top: 15px;
            margin-bottom: 0;
            white-space: nowrap;
            padding-left: 30px;
            padding-bottom: 0px;

            &:before {
                content: '';
                position: absolute;
                top: 8px;
                left: 15px;
                border-top: 2px solid #000;
                opacity: 0.2;
                display: block;
                width: 50px;
            }

            &:first-child {
                padding-top: 0;
            }
            span {
                opacity: 0;
            }
        }
    }
    img.customLogo {
        width: 40px;
    }

    /* Profile */
    .signout {
        margin: 15px 0 5px 0;
        font-size: 1.4rem;
        font-weight: bold;
        color: var(--danger);
        width: 100%;
        text-align: center;
        &:hover {
            color: var(--danger-darken-20);
        }
    }
    .profile {
        padding: 15px 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        color: var(--color-txt);

        &:hover {
            text-decoration: none;
        }

        .tag {
            font-size: 1.4rem;
            font-weight: 600;
            align-items: center;
            background-color: hsl(0, 0%, 96%);
            border-radius: 4px;
            color: hsl(0, 0%, 29%);
            display: inline-flex;
            height: 2em;
            justify-content: center;
            line-height: 1.5;
            padding-left: 0.75em;
            padding-right: 0.75em;
            white-space: nowrap;
        }
        .name {
            font-size: 1.6rem;
            line-height: 22px;
            text-align: center;
            ///.truncate();
            max-width: 100%;
        }
        .email {
            color: var(--color-txt);
            opacity: 0.5;
            ///.truncate();
            max-width: 100%;
            font-size: 1.2rem;
        }
        .avatar {
            margin: 0;
        }
    }
    .copy-footer {
        padding: 15px 0 0 0;
        margin: 0px 0 10px 0;
        font-size: 1.1rem;
        text-align: center;
        width: 100%;
    }
}

/* Tooltip
========================================================== */
html body .tooltip {
    display: block !important;
    z-index: 10000;
    outline: none;

    &.active .tooltip-inner {
        background: var(--sidebar-active-bg);
        color: var(--sidebar-active-color);
    }

    .tooltip-inner {
        background: var(--sidebar-hover-bg);
        color: var(--sidebar-hover-color);
        border-radius: 6px;
        padding: 5px 10px 4px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        border: 0;
        font-weight: 500;
        max-width: inherit;
    }

    .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: var(--sidebar-active-bg);
        z-index: 1;
        display: none;
    }

    &[x-placement^='top'] {
        margin-bottom: 5px;

        .tooltip-arrow {
            border-width: 5px 5px 0 5px;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-bottom-color: transparent !important;
            bottom: -5px;
            left: calc(50% - 5px);
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    &[x-placement^='bottom'] {
        margin-top: 5px;

        .tooltip-arrow {
            border-width: 0 5px 5px 5px;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-top-color: transparent !important;
            top: -5px;
            left: calc(50% - 5px);
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    &[x-placement^='right'] {
        margin-left: 10px;

        .tooltip-arrow {
            border-width: 5px 5px 5px 0;
            border-left-color: transparent !important;
            border-top-color: transparent !important;
            border-bottom-color: transparent !important;
            left: -5px;
            top: calc(50% - 5px);
            margin-left: 0;
            margin-right: 0;
        }
    }

    &[x-placement^='left'] {
        margin-right: 5px;

        .tooltip-arrow {
            border-width: 5px 0 5px 5px;
            border-top-color: transparent !important;
            border-right-color: transparent !important;
            border-bottom-color: transparent !important;
            right: -5px;
            top: calc(50% - 5px);
            margin-left: 0;
            margin-right: 0;
        }
    }

    &.popover {
        $color: #f9f9f9;
        z-index: 99999;

        .popover-inner {
            background: #fff;
            color: var(--color-txt);
            padding: 15px;
            border-radius: 5px;
            box-shadow: 0 5px 30px rgba(black, 0.1);
        }

        .popover-arrow {
            border-color: #fff;
        }
    }

    &[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.15s, visibility 0.15s;
    }

    &[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity 0.15s;
    }
}

/* Mobile Friendly */
@media only screen and (max-width: 767px) {
    body.sidebar-expanded {
        //hide scrollbars when content is bigger
        overflow: hidden;
        height: 100vh;
    }
    nav.navbar.navbar-sidebar {
        width: 100vh !important;
        position: fixed;
        height: 80px;
        overflow: hidden;

        .brand-container {
            flex-direction: row;
            justify-content: space-between;
            width: 100vw;
            height: 80px;
            padding: 0 15px;
            margin: 0;

            .brand {
                display: flex;
            }
            .brand-collapsed {
                display: none;
            }
        }

        .navbar-nav {
            display: none;
        }

        &.is-expanded {
            width: 100vw !important;
            height: 100vh !important;
            .navbar-nav {
                display: flex;
            }
        }
    }
}
</style>
